import { type FC } from 'react';
import Photo24 from './Photo24.tsx';
import Photo40 from './Photo40.tsx';
import Photo48 from './Photo48.tsx';

type PhotoProps = {
    variation: '24' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Photo24,
    Photo40,
    Photo48,
};

const Photo: FC<PhotoProps> = ({ variation, ...props }) => {
    const variationKey = `Photo${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        return null;
    }

    return <Icon {...props} />;
};

export default Photo;
